import React, { useState } from 'react';
import { styled } from '@mui/material/styles';
import {
    Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper,
    Typography, Box, Divider, Grid, Button
} from "@mui/material";
import { Payment } from '../../Svg';
import { fomateDate } from '../../utils/fomateDate';
import { dispatchScheduleorderThunk } from '../../redux/schedulecartslice';
import { useDispatch } from 'react-redux';

const TableHeads = styled(TableCell)(() => ({
    fontSize: "14px",
    color: "#727A90 !important",
    fontFamily: `'Public Sans', sans-serif !important`,
}));

const ActionButton = styled(Button)(({ theme }) => ({
    textTransform: 'none',
    marginRight: theme.spacing(1),
    fontSize: '0.875rem',
    color: '#512DA8',
    fontSize: '14px',
    fontWeight: '600 !important',
    fontFamily: `'Public Sans', sans-serif`,
    '&:hover': {
        backgroundColor: theme.palette.grey[200],
    },
}));

const TableCells = styled(TableCell)(() => ({
    fontFamily: `'Public Sans', sans-serif !important`,
    fontSize: "14px",
    color: '#0C0D0F',
}));

const OrderDetailsProds = ({ products, price, id, status }) => {
    const dispatch = useDispatch()
    const [selectedProducts, setSelectedProducts] = useState([]);
    const [loading, setLoading] = useState(false);

    const handleCheckboxChange = (productId) => {
        setSelectedProducts((prev) =>
            prev.includes(productId)
                ? prev.filter(id => id !== productId)
                : [...prev, productId]
        );
    };

    const isProductSelected = (productId) => selectedProducts?.includes(productId);
    console.log(selectedProducts);

    const handleDispatch = async () => {
        const productUpdates = selectedProducts?.map(i => (
            {
                productId: i
            }
        ))
        const data = {
            id,
            productUpdates
        }
        console.log(productUpdates);
        setLoading(true)
        await dispatch(dispatchScheduleorderThunk(data))
        setLoading(false)
    }

    return (
        <div>
            {selectedProducts?.length > 0 &&
                <div style={{ display: 'flex', justifyContent: 'flex-end' }}>

                    <ActionButton sx={{ background: '#512DA8', color: '#fff' }} onClick={handleDispatch} disabled={loading}>{loading ? 'please wait...' : 'Dispatch Order'}</ActionButton>
                </div>
            }
            <Grid item xs={12} md={6} sx={{ p: '24px 0' }}>
                <Paper sx={{ boxShadow: '0px 4px 30px 0px #4D54640D', border: '1px solid #DCDEE3', borderRadius: "16px" }}>
                    <Box sx={{ p: 2 }} display="flex" alignItems="center">
                        <Payment />
                        <Typography style={{ marginLeft: '10px', fontSize: '18px', fontWeight: "600" }}>
                            Product
                        </Typography>
                        <Typography style={{ marginLeft: '10px', padding: "6px 4px", borderRadius: '8px', fontSize: '14px', fontWeight: "600", background: "#EAFFFE", color: '#006C64' }}>
                            {products?.length} Products
                        </Typography>
                    </Box>
                    <Divider sx={{ mb: 1 }} />
                    <TableContainer>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableHeads>Product</TableHeads>
                                    <TableHeads>Total Quantity</TableHeads>
                                    <TableHeads>Scheduled Quantity</TableHeads>
                                    <TableHeads>Pending Quantity</TableHeads>
                                    <TableHeads>Price</TableHeads>
                                    <TableHeads>Schedule Date</TableHeads>
                                    <TableHeads>Total</TableHeads>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {products?.map((i) => (
                                    
                                    <>
                                        {i?.rescheduled != true &&
                                            <TableRow key={i._id}>
                                                <TableCells>
                                                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                        {(status === "AWAITING" ) &&
                                                            <input
                                                                type="checkbox"
                                                                checked={isProductSelected(i.productId)}
                                                                onChange={() => handleCheckboxChange(i.productId)}
                                                            />
                                                        }
                                                        <div>
                                                            <img
                                                                src={i?.productDetails?.assets?.featuredImage[0] || "/assets/profile.png"}
                                                                style={{ width: 44, height: 44, borderRadius: 2 }}
                                                                alt="product"
                                                            />
                                                        </div>
                                                        <div>
                                                            <strong style={{ color: '#1D1F2C' }}>
                                                                {i?.productDetails?.productOverview?.productNumber[0]}
                                                            </strong>
                                                            <div style={{ fontSize: '14px', color: '#667085', fontWeight: '500' }}>
                                                                {i?.productDetails?.productOverview?.manufacturer[0]?.name}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </TableCells>
                                                <TableCells>{i?.totalQty}</TableCells>
                                                <TableCells>{i?.quantity}</TableCells>
                                                <TableCells>{i?.pendingOrderCount}</TableCells>
                                                <TableCells>₹{i?.unitPrice?.toFixed(2)}</TableCells>
                                                <TableCells>{fomateDate(i?.deliveryDate)}</TableCells>
                                                <TableCells>₹{(i?.quantity * i?.unitPrice)?.toFixed(2)}</TableCells>
                                            </TableRow>
                                        }
                                    </>
                                ))}

                                {products?.map((i) => (
                                    <>
                                        {i?.rescheduled == true &&
                                            <>
                                                <TableRow key={i._id}>
                                                    <TableCells style={{ background: '#F1F1F3', color: '#5D5FEF' }}>
                                                        <div > Reschedule details</div>
                                                    </TableCells>
                                                    <TableCells style={{ background: '#F1F1F3', color: '#5D5FEF' }}></TableCells>
                                                    <TableCells style={{ background: '#F1F1F3', color: '#5D5FEF' }}>
                                                        <div >Required qty :{i?.rescheduledQuantity}</div>
                                                    </TableCells>
                                                    <TableCells style={{ background: '#F1F1F3', color: '#5D5FEF' }}>
                                                        <div>Reschedule date : {fomateDate(i?.rescheduleDate)}</div>
                                                    </TableCells>
                                                    <TableCells style={{ background: '#F1F1F3', color: '#5D5FEF' }}></TableCells>
                                                    <TableCells style={{ background: '#F1F1F3', color: '#5D5FEF' }}></TableCells>
                                                    <TableCells style={{ background: '#F1F1F3', color: 'red' }}>
                                                        <div >On delivery</div>
                                                    </TableCells>
                                                </TableRow>
                                                <TableRow key={i._id}>
                                                    <TableCells>
                                                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                            {( status == "RESCHEDULE") &&
                                                                <input
                                                                    type="checkbox"
                                                                    checked={isProductSelected(i.productId)}
                                                                    onChange={() => handleCheckboxChange(i.productId)}
                                                                />
                                                            }
                                                            <div>
                                                                <img
                                                                    src={i?.productDetails?.assets?.featuredImage[0] || "/assets/profile.png"}
                                                                    style={{ width: 44, height: 44, borderRadius: 2 }}
                                                                    alt="product"
                                                                />
                                                            </div>
                                                            <div>
                                                                <strong style={{ color: '#1D1F2C' }}>
                                                                    {i?.productDetails?.productOverview?.productNumber[0]}
                                                                </strong>
                                                                <div style={{ fontSize: '14px', color: '#667085', fontWeight: '500' }}>
                                                                    {i?.productDetails?.productOverview?.manufacturer[0]?.name}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </TableCells>
                                                    <TableCells>{i?.totalQty}</TableCells>
                                                    <TableCells>{i?.quantity}</TableCells>
                                                    <TableCells>{i?.pendingOrderCount}</TableCells>
                                                    <TableCells>₹{i?.unitPrice?.toFixed(2)}</TableCells>
                                                    <TableCells>{fomateDate(i?.deliveryDate)}</TableCells>
                                                    <TableCells>₹{(i?.quantity * i?.unitPrice)?.toFixed(2)}</TableCells>
                                                </TableRow>
                                            </>
                                        }
                                    </>
                                ))}
                                {/* Subtotal Row */}
                                <TableRow>
                                    <TableCells colSpan={5}></TableCells>
                                    <TableCells>Subtotal</TableCells>
                                    <TableCells>₹{price?.subTotal?.toFixed(2)}</TableCells>
                                </TableRow>
                                <TableRow>
                                    <TableCells colSpan={5}></TableCells>
                                    <TableCells>VAT (0%)</TableCells>
                                    <TableCells>₹{price?.tax?.toFixed(2)}</TableCells>
                                </TableRow>
                                <TableRow>
                                    <TableCells colSpan={5}></TableCells>
                                    <TableCells sx={{ borderBottom: 'none !important' }}>Shipping Rate</TableCells>
                                    <TableCells>₹{price?.otherCharges?.toFixed(2)}</TableCells>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Paper>

                <Paper sx={{ padding: '20px 30px', mt: 2, boxShadow: '0px 4px 30px 0px #4D54640D', border: '1px solid #DCDEE3', borderRadius: "16px" }}>
                    <Box display="flex" justifyContent="space-between" fontWeight="bold">
                        <Typography variant="h6" sx={{ fontSize: '18px', fontWeight: 600 }}>Grand Total:</Typography>
                        <Typography variant="h6" sx={{ fontSize: '18px', fontWeight: 600 }}>₹{price?.total?.toFixed(2)}</Typography>
                    </Box>
                </Paper>
            </Grid>
        </div>
    );
};

export default OrderDetailsProds;
